import "./App.css";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { useGlobalStore } from "./store/useGlobalStore";
// Import your other components here
// import { useSelector } from "react-redux";
import Mainpage from "./components/mainpage";
import QSETMainpage from "./components/qsetmainpage";
import QSETDashboard from "./components/qsetdashboard";
import Dashboard from "./components/dashboard";
import TeamTaskUpdates from "../src/components/teamTaskUpdates";
import MyInternalTaskUpdates from "../src/components/myInternalTaskUpdates";
import MySelection from "../src/components/mySelection";
import TeamSelection from "../src/components/TeamSelection";
import AllSelections from "./components/allSelections";
import MyJds from "./components/myJDs";
import AssignedJds from "./components/assignedJDs";
import JdsDashboard from "../src/components/jdsDashBoard";
import JdsPriority from "../src/components/jdsPriority";
import InterviewCalendar from "../src/components/interviewCalendar"
import Createjd from "./components/createJD";
import Signin from "./authentication/Signin";
import SignupNew from "./authentication/Signupnew";
import Otpscreen from "./components/otpscreen/otpscreen";
import OTPProcess from "./components/otpprocess/otpprocess";
import Settings from "./components/settings";
import Customers from "./components/customers";
import SpecificCustomer from "./components/specificCustomer";
import TAList from "./components/specificCustomer/ListOfTA";
import BarredCompanyList from "./components/specificCustomer/ListOfBarredCompany";
import TimeSheet from "./components/timeSheet";
import ContactBook from "./components/contactBook";
import Holidays from "./components/holidays";
import ResumeSource from "./components/resumeSource";
import Profile from "./components/profile/profile";
import JDs from "./components/JDs";
import ResumeDataBase from "./components/ResumeDataBase";
import ResumeDBSearch from "./components/resumeDBSearch";
import ResumeDbSearchResults from "./components/resumeDbSearchResults"
import MainpageStats from "./components/fromTeamMember/mainpage";
import Landing from "./landing"
import CareerWebsites from "./landing/careerWebsites";
import ResumeAnalysisFree from "./landing/resumeAnalysisFree";
import JDsConsolidated from "./components/JdsConsolidated";
import JobApplicationForm from "./landing/jobApplicationForm"
import Notifications from "./components/notifications";
import QHRFlowLanding from "./landing/qhrFlowlanding";
import QHRFlowContact from "./landing/qhrFlowContact";
import QHRFVendorConnect from "./landing/qhrFlowVendorConnect";
import SuperUser from "./components/superuser";
import SuperAdmin from "./components/superadmin";
import UserSubscription from "./components/usersubscription";
import CandidateDescription from "./components/candidateDescription";
import OTPProcessCandidates from "./components/otpprocessCandidates";
import AllEvaluations from "./components/AllEvaluations";
import QsetCandidateExamCardList from "./components/qsetCandidateExamCardList";
import QSETJD from "./components/qsetjd";
import QSETCandidateProfile from "./components/qsetcandidateProfile";
import QSETViewJDPage from "./components/QsetViewJDPage";
import EvalAnalytics from "./components/evalAnalytics";
import LoadingSpinner from "./components/loadingSpinner";
import StatsAnalytics from "./components/StatsAnalytics";
import RDBDescription from "./components/RDBDescription";
import MyTimeSheet from "./components/myTimeSheet";
import QSETJdDetails from "./components/qsetjddetails";
import QsetPreStart from "./components/qsetprestart";
import CurrentEvalsAll from "./components/currentEvalsAll";
import JDSearch from "./components/JDSearch";
import TeamAssignmentPages from "./components/teamAssignmentPages";
import MyDashBoardPages from "./components/myDashboardPages";
import Sourcing from "./components/Sourcing";
import NUJobsOTPProcess from "./components/nujobs/nujobsotpprocess/nujobsotpprocess";
import NuJobsSignup from "./authentication/NujobsSignup";
import NuJobsTransactions from "./components/nujobs/nujobsmainpage";
import NuJobsDashboard from "./components/nujobs/nujobsdashboard";
import JobListingsPage from "./landing/nujobs/jobListingPage";
import JobListingSearchResults from "./landing/nujobs/jobListingSearchResults";
import JobListingSearchResultsPage from "./landing/nujobs/jobListingSearchResultsPage";
import NUJobsMyResumes from "./components/nujobs/nujobsMyResumes";
import NuJobsCandidateProfile from "./components/nujobs/nujobscandidateProfile";
import NuJobsSearchResults from "./components/nujobs/nujobsSearchResults";
import NuJobsPostedJDs from "./components/qhrflowNuJobs/nuJobsPostedJDs";
import SourcingNuJobs from "./components/SourcingNuJobs";
import SourcingVendors from "./components/SourcingVendors";
import SourcingAutomation from "./components/SourcingAutomation";
import NuJobsAllResumes from "./components/qhrflowNuJobs/nuJobsAllResumes";
import TeamStatsAnalytics from "./components/TeamStatsAnalytics";
import NuJobsCandidateProfilePreview from "./components/nujobs/nujobsCandidateProfilePreview";
import GlobalEvaluation from "./components/globalEvaluation";
import NuJobsEvalDashboard from "./components/nujobs/nujobsEvalDashboard";
import NuJobsEvaluationsReadyPage from "./components/nujobs/nujobsEvaluationReadyPage";
import NuJobsCandidateExamCardList from "./components/nujobs/nujobsCandidateExamCardList";
import NuJobsMyEvals from "./components/nujobs/nujobsMyEvals";
import NuJobsMyEvalsResults from "./components/nujobs/nujobsMyEvalsResults";
import NuJobsSkillsMatchingSearchResults from "./components/nujobs/nujobsSkillsMatchingSearchResults";
import NuJobsViewedJobsSearchResults from "./components/nujobs/nujobsViewedJobsSearchResults";
import NuJobsFavJobsSearchResults from "./components/nujobs/nujobsFavJobsSearchResults";
import NuJobsAppliedJobsSearchResults from "./components/nujobs/nujobsAppliedJobsSearchResults";
import NuJobsViewJobsContainer from "./components/nujobs/nujobsViewJobsContainer";
import NuJobsViewJobsContainerOpenSearch from "./components/nujobs/nujobsViewJobsContainerOpenSearch";
import NuJobsViewJobDetailsLink from "./components/nujobs/nujobsViewJobDetailsLink";
import NUJobsSubscription from "./components/nujobs/nujobsSubscription";
import NUJobsProfile from "./components/nujobs/nujobsprofile/nujobsProfile";
import PrivacyPolicy from "./landing/privacyPolicy";
import TermsAndConditions from "./landing/termsAndConsditions";
import CookiePolicy from "./landing/cookiePolicy";
import NuJobsContact from "./landing/nujobsContact";
import Disclaimer from "./landing/disclaimer";
import AboutUs from "./landing/aboutus";
import NuJobsApplyNowAfterLogin from "./components/nujobs/nujobsApplyNowAfterLogin";
import NuJobsNotifications from "./components/nujobs/nujobsNotifications";
import QHRSET from "./landing/qhrSet";
import NUJobsUserAnalytics from "./components/nujobs/nujobsUserAnalytics";
import NuJobsEmployerDashboard from "./components/nuJobsEmployerDashboard";
import NuJobsEmployerPage from "./landing/nujobsEmployerPage";
import CompanyAnalytics from "./components/superuser/analytics/companyAnalytics";
import JdsPriorityInternal from "./components/jdsPriorityInternal";
import NuJobsAssignments from "./components/qhrflowNuJobs/nuJobsAssignments";
import NuJobsJDsPriority from "./components/qhrflowNuJobs/nuJobsJDsPriority";
import NuJobsJDsPriorityInternal from "./components/qhrflowNuJobs/nuJobsJDsPriorityInternal";
import NuJobsCreateJD from "./components/qhrflowNuJobs/nuJobsCreateJD";
import NuJobsEmployerHelp from "./components/nujobsEmployerHelp";
import NuJobsSuperAdmin from "./components/nujobsSuperadmin";
import JobListingWhoIsHiringNow from "./landing/nujobs/jobListingWhoIsHiringNow";
import JobListingWhoIsHiringNowPage from "./landing/nujobs/jobListingWhoIsHiringNowPage";
import NuJobsWhoisHiringCompanyPage from "./landing/nujobs/jobListingWhoIsHiringNowCompanyPage";
import JdEventsPage from "./components/JdEventsPage";
import JobListingEventsPage from "./landing/nujobs/jobListingEventsPage";
import NuJobsEvents from "./components/qhrflowNuJobs/nuJobsEvents";

var PrivateRoute = (props) => {
  //const authFlag = useSelector((state) => state.authReducer.authFlag);
  const authDetail = localStorage.getItem("userDetails");

  if (authDetail) {
    return <Outlet />;
  }
  const hostname = window.location.hostname;
  if (hostname === "nujobs.quallyhireai.com") {
    return <Navigate to="/nujobs" replace />;
  }
  return <Navigate to="/home" replace />;
  // return <Outlet />;
};
var QSETPrivateRoute = (props) => {
  var authDetailQSet = localStorage.getItem("qsetUserDetails");
  return authDetailQSet ? <Outlet /> : <Navigate to="/home" />;
};

var NUJobsPrivateRoute = (props) => {
  var authDetailNuJobs = localStorage.getItem("nujobsUserDetails");
  return authDetailNuJobs ? <Outlet /> : <Navigate to="/" replace />;
};

const JdsRoutes = () => (
  <>
    <Route path=":value/:product?" element={<Createjd />}>
      <Route
        path="candidateProfile/:id/:resumeID/:view"
        element={<CandidateDescription />}
      />
    </Route>
  </>
);
const DomainLanding = () => {
  const hostname = window.location.hostname;

  // NuJobs domain
  if (hostname === "nujobs.quallyhireai.com") {
    return <JobListingsPage />;
  }

  // QuallyHire domain
  return <Landing />;
};
function App() {
  const isLoading = useGlobalStore((state) => state.isLoading);
  const [interceptorsReady, setInterceptorsReady] = useState(false);
  const setupInterceptors = useGlobalStore((state) => state.setupInterceptors);

useEffect(() => {
  const favicon = document.querySelector("link[rel='icon']");

  if (favicon) {
    favicon.href =
      window.location.hostname === "nujobs.quallyhireai.com"
        ? "/NujobsFavicon.png"
        : "/QFavicon.png"; 
  }
}, []);

  useEffect(() => {
    // It's good practice to call the cleanup function on unmount
    const cleanup = setupInterceptors();
    setInterceptorsReady(true);
    return () => cleanup();
  }, [setupInterceptors]);

  if (!interceptorsReady) return null;

  return (
    <div id="main">
      {isLoading && <LoadingSpinner />}
      <div id="body">
        <Routes>
          {/* Domain based landing page */}
          <Route path="/" element={<DomainLanding />} />
          
          <Route path="/home" element={<Landing />} />
          <Route path="/qhrflow" element={<QHRFlowLanding />} />
          <Route path="/qhrflowcontact" element={<QHRFlowContact />} />          
          <Route path="/qhrflowvendorconnect" element={<QHRFVendorConnect />} />
          <Route path="/login" element={<Signin />} />
          <Route path="/signup/:product" element={<SignupNew />} />
          <Route path="/otp" element={<Otpscreen />} />
          <Route path="/otpprocess/:product" element={<OTPProcess />} ></Route>           
          <Route path="/nujobs" element={<JobListingsPage />} />  
          <Route path="/nujobswhoishiringnow" element={<JobListingWhoIsHiringNowPage />} />
          <Route path="/nujobswhoishiringnowcompany/company/:qhoid" element={<NuJobsWhoisHiringCompanyPage />} />
          <Route path="/nujobsupcomingevents" element={<JobListingEventsPage />} />
          
          <Route path="/jobListingSeachResults" element={<JobListingSearchResults />} />
          <Route path="/jobListingSearchResultsPage" element={<JobListingSearchResultsPage />} />
          <Route path="/resumeAnalysisFree" element={<ResumeAnalysisFree />} />          
          <Route path="/careerWebsites" element={<CareerWebsites />} />
          <Route path="/application/:qhoid/:qhuid/:jdID/:resumeID" element ={<JobApplicationForm />} />  
          <Route path="/otpprocesscandidate/:name/:qhoid/:jdID/:resumeID" element={<OTPProcessCandidates />} ></Route> 
          <Route path="/nujobssignup" element={<NuJobsSignup />} /> 
          <Route path="/nujobsotpprocess" element={<NUJobsOTPProcess />} ></Route>  
          <Route path="/nujobsViewJobsContainerOpenSearch/:source/:jdid/:qhoid?" element={<NuJobsViewJobsContainerOpenSearch />}/>               
          
          <Route path="/nujobslink/:qhoid/:qhcompanyjid" element={<NuJobsViewJobDetailsLink />}/>               
          <Route path="/job/:qhoid/:qhcompanyjid" element={<NuJobsViewJobDetailsLink />}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />  
          <Route path="/terms-conditions" element={<TermsAndConditions />} />   
          <Route path="/cookie-policy" element={<CookiePolicy />} />   
          <Route path="/nujobscontact" element={<NuJobsContact />} />
          <Route path="/disclaimer" element={<Disclaimer />} />  
          <Route path="/aboutus" element={<AboutUs />} />    
          <Route path="/qhrset" element={<QHRSET />} />  
          <Route path="/nujobsemployerpage" element={<NuJobsEmployerPage />} />   
          <Route path="/qsethome" element={<QSETPrivateRoute />}>
            <Route element={<QSETMainpage hideSidebar={false} />}>
              <Route index element={<Navigate to="qsetdashboard" />} />
              <Route exact path="qsetdashboard" element={<QSETDashboard />} />
              <Route path="qsetjd" element={<QSETJD />} />
              <Route path="qsetjdview" element={<QSETViewJDPage />} />
              <Route path="qsetjd/:value" element={<QSETJdDetails />} />
              <Route path="qsetcandidateprofile" element={<QSETCandidateProfile />}/>
            </Route>
            <Route path="qset" element={<QSETMainpage hideSidebar={true} />}>
              <Route path="prestart/:ev_id" element={<QsetPreStart />} />
                  <Route path="qsetcandidateexamcardlist/:ev_id" element={<QsetCandidateExamCardList />} />
              </Route>
          </Route>

          <Route path="/nujobshome" element={<NUJobsPrivateRoute />}>
            <Route element={<NuJobsTransactions hideSidebar={true} />}>
              <Route index element={<Navigate to="nujobssearch" />} />
              <Route exact path="nujobssearch" element={<NuJobsDashboard/>} />
              <Route
                path="nujobsSearchResultHandler"
                element={<NuJobsSearchResults />}
              />
              <Route
                path="nujobsCandidateProfile"
                element={<NuJobsCandidateProfile />}
              />
              <Route path="nujobsMyResumes" element={<NUJobsMyResumes />} />
              <Route
                path="nujobsViewJobsContainer/:source/:jdid"
                element={<NuJobsViewJobsContainer />}
              />        
              <Route
                path="nujobsCandidateProfilePreview/:resumeID"
                element={<NuJobsCandidateProfilePreview />}
              />
              <Route
                path="nujobsEvaluations"
                element={<NuJobsEvalDashboard />}
              />
              <Route
                path="nujobsEvaluations/readyPage/:ev_id"
                element={<NuJobsEvaluationsReadyPage />}
              />
              <Route path="nujobsMyEvals" element={<NuJobsMyEvals />} />
              <Route
                path="nujobsMyEvals/:ev_id"
                element={<NuJobsMyEvalsResults />}
              />
              <Route path="nujobsSkillsMatchingSearchResults" element={<NuJobsSkillsMatchingSearchResults/>}/>   
              <Route path="nujobsViewedJobsSearchResults" element={<NuJobsViewedJobsSearchResults/>}/>  
              <Route path="nujobsFavJobsSearchResults" element={<NuJobsFavJobsSearchResults/>}/>      
              <Route path="nujobsAppliedJobsSearchResults" element={<NuJobsAppliedJobsSearchResults/>}/>
              <Route path="nujobssubscription" element ={<NUJobsSubscription/>} /> 
              <Route path="nujobsprofile" element ={<NUJobsProfile/>} /> 
              <Route path="nujobsafterlogin/:qhoid/:qhcompanyjid" element={<NuJobsApplyNowAfterLogin/>}/>      
              <Route path="nujobsnotifications" element={<NuJobsNotifications />}></Route>  
              <Route path="nujobsuseranalytics" element={<NUJobsUserAnalytics />}></Route>          
                                                 
            </Route>                                                                                            
            <Route
              path="nujobs"
              element={
                <NuJobsTransactions hideSidebar={true} hideHeader={true} />
              }
            >
              <Route
                path="qsetcandidateexamcardlist/:ev_id"
                element={<NuJobsCandidateExamCardList />}
              />
            </Route>
          </Route>

          <Route element={<PrivateRoute />}>
            <Route element={<Mainpage />}>
              <Route index element={<Navigate to="dashboard" />} />
              <Route path="profile" element={<Profile />} />
              <Route path="superuser" element ={<SuperUser/>} />
              <Route path="timesheet" element={<TimeSheet />} />
              <Route path="superadmin" element ={<SuperAdmin/>} />
              <Route path="usersubscription" element ={<UserSubscription/>} /> 
              <Route path="statsanalytics" element ={<StatsAnalytics/>} />             
              <Route exact path="dashboard" element={<Dashboard />} />
              <Route exact path="nujobsemployerdashboard" element={<NuJobsEmployerDashboard />} />  
              <Route path="nujobsemployersuperadmin" element={<NuJobsSuperAdmin />}></Route>  
              <Route path="nujobsemployerhelp" element={<NuJobsEmployerHelp />}></Route>                          
              <Route path="companyanalytics/:qhoid" element={<CompanyAnalytics />}></Route>                            
              <Route path="mySelection" element={<MySelection />} />
              <Route path="teamSelection" element={<TeamSelection />} />
              <Route path="allSelections" element={<AllSelections />} />
              <Route path="teamStatsAnalytics" element={<TeamStatsAnalytics />} />
              <Route path="jdsDashboard" element={<JdsDashboard />} />
              <Route path="jdsPriority" element={<JdsPriority />} /> 
              <Route path="jdsPriorityinternal" element={<JdsPriorityInternal />} />  
              <Route path="jdseventpage" element={<JdEventsPage />} />  
              <Route path="nujobsjdsPriority" element={<NuJobsJDsPriority />} /> 
              <Route path="nujobsjdsPriorityInternal" element={<NuJobsJDsPriorityInternal />} />      
              <Route path="nujobsevents" element={<NuJobsEvents />} />                              
              <Route path="resume_source" element={<ResumeSource />} />
              <Route path="From_My_Team" element={<MainpageStats />}>
                {/* Add more routes inside Fromteammember */}
                {/* <Route index element={<Navigate to="" />} /> */}
                {/* Add as many routes as needed */}
              </Route>
              <Route path="globalEvaluations" element={<GlobalEvaluation />} />
              
              <Route path="settings" element={<Settings />} />
              <Route path="users" element={<Settings />} />
              <Route path="customers" element={<Customers />} />
              <Route path="specificCustomer">
                <Route index element={<Customers />} />
                <Route
                  path=":clientID/:clientName"
                  element={<SpecificCustomer />}
                >
                   <Route index element={<Navigate to="tas" replace />} />
                  <Route path="tas" element={<TAList />} />
                  <Route path="barred" element={<BarredCompanyList />} />
                </Route>
              </Route>
              <Route path="mytimeSheet" element={<MyTimeSheet />} />
              <Route path="contactBook" element={<ContactBook />} />
              <Route path="evalanalytics" element={<EvalAnalytics />} />
              <Route path="holidays" element={<Holidays />} />
              <Route path="allEvaluations" element={<AllEvaluations />} />
              <Route path="notifications" element={<Notifications />}></Route>
              <Route path="createJd" element={<Createjd />} />
              <Route path="nujobscreateJd" element={<NuJobsCreateJD />} />
              <Route path="resumeDataBase" element={<ResumeDataBase />} />
              <Route path="resumeDataBase/:resumeID" element={<RDBDescription />} />
              <Route path="resumes" element={<ResumeDBSearch />} />
              <Route path="resultsDB" element={<ResumeDbSearchResults />} />
              <Route path="resultsDB/:resumeID" element={<RDBDescription />} />             
              {[
                { path: "nujobposts", element: <NuJobsPostedJDs /> },
                { path: "nujobsapplications", element: <NuJobsAllResumes /> },
                { path: "nujobsjdAssignments", element: <NuJobsAssignments /> },                
                { path: "jds", element: <JDs /> },
                { path: "assignedJds", element: <AssignedJds /> },
                { path: "teamTaskUpdates", element: <TeamTaskUpdates /> },
                { path: "sourcing", element: <Sourcing /> },
                { path: "sourcingNujobs", element: <SourcingNuJobs /> },
                { path: "sourcingVendors", element: <SourcingVendors /> }, 
                { path: "sourcingAutomation", element: <SourcingAutomation /> },             
                { path: "jdAssignments", element: <JDsConsolidated /> },
                { path: "InterviewCalendar", element: <InterviewCalendar /> },
                {
                  path: "TeamAssignmentPages",
                  element: <TeamAssignmentPages />,
                },
                { path: "myDashboardPages", element: <MyDashBoardPages /> },
                {
                  path: "myInternalTaskUpdates",
                  element: <MyInternalTaskUpdates />,
                },
                { path: "MyJds", element: <MyJds /> },
                { path: "currentEvals", element: <CurrentEvalsAll /> },
                { path: "searchJd", element: <JDSearch /> },
              ].map((route) => (
                <Route key={route.path} path={route.path}>
                  <Route index element={route.element} />
                  {JdsRoutes()}
                </Route>
              ))}
              <Route index element={<Outlet />} />
            </Route>
          </Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
